import { AppContext } from '../libs/context'
import { getMonthEnd } from '../libs/appsSheet'
import { opsAPI } from '../api/retail'
import Excel from 'exceljs'

import {
  Box,
  Button,
  Calendar,
  CheckBox,
  CheckBoxGroup,
  FormField,
  Heading,
  Layer,
  Main,
  Select,
  Stack,
  Text,
  TextInput
} from 'grommet'
import { DropWithHeading, LoadingHeader, PageHeader } from './Common'
import { Filter } from 'grommet-icons'
import GridLoader from 'react-spinners/GridLoader'
import React, { Component } from 'react'
import update from 'immutability-helper'
import { PageCard } from './Cards'
import fi from 'react-timeago/lib/language-strings/fi'
import ca from 'react-timeago/lib/language-strings/ca'
import { MotionBox } from './Motion'
import { AnimatePresence } from 'framer-motion'
import { debounce } from '../libs/common'
import { saveAs } from 'file-saver'

class Filters extends Component {
  state = {
    selected: {},
    allowUpdate: false,
    search: {}
  }
  componentDidMount() {
    this.props.selected && this.setState({ selected: this.props.selected })
  }
  updateFilterField = (field, checked, value = undefined) => {
    const { selected } = this.state
    const { defaultValue, optionProps = {}, useCheckBoxValue = false } = this.getFieldProps(field)
    let componentValue = defaultValue
    // determine if value needs to be set for an object which may be passed as options array
    // currently only affects `Select` component
    if (optionProps.valueKey && value !== undefined) {
      componentValue = value[optionProps.valueKey] || defaultValue
    } else if (value !== undefined) {
      componentValue = value
    }
    let obj = {
      [field]: {
        $set: checked
          ? { value: useCheckBoxValue ? checked : componentValue, searchedOptions: undefined }
          : undefined
      }
    }
    this.setState(
      {
        selected: update(selected, obj)
      },
      () => {
        this.setState({ allowUpdate: this.props.selected !== this.state.selected })
      }
    )
  }
  triggerUpdateAction = () => {
    const { updateFiltersAction } = this.props
    updateFiltersAction && updateFiltersAction(this.state.selected)
  }
  getSelectedFieldNames = () => {
    let fields = []
    const { selected } = this.state
    Object.keys(selected).forEach((key) => {
      if (selected[key]) {
        fields.push(key)
      }
    })
    return fields
  }
  isFieldSelected = (field) => {
    return !!this.state.selected[field]
  }
  getFieldProps = (field) => {
    return this.props.apiFilters.find((obj) => obj.field === field) || {}
  }
  searchTest = (o, optionProps = {}) => {
    // this will account for searching objects if a label key was passed in options
    if (optionProps.labelKey) {
      return o[optionProps.labelKey] && o[optionProps.labelKey].toLowerCase()
    } else if (o) {
      return o.toLowerCase()
    }
  }
  searchOptions = (field, value) => {
    if (value && value.length > 1) {
      const { options, optionProps } = this.getFieldProps(field)
      const { selected } = this.state

      const exp = new RegExp(value.toLowerCase(), 'i')
      if (selected[field]) {
        let obj = {
          [field]: {
            searchedOptions: {
              $set: value
                ? options.filter((o) => exp.test(this.searchTest(o, optionProps)))
                : undefined
            }
          }
        }
        this.setState({ selected: update(selected, obj) })
      }
    }
  }
  getRenderComponent = (field) => {
    const { selected } = this.state
    const { options, placeholder, optionProps = {}, useCheckBoxValue = false } = this.getFieldProps(
      field
    )
    const commonProps = {
      value: optionProps.valueKey
        ? options.find((i) => i[optionProps.valueKey] === selected[field].value) || {}
        : selected[field].value,
      placeholder: placeholder
    }
    if (options) {
      return (
        <Select
          options={
            selected[field] && selected[field]['searchedOptions']
              ? selected[field]['searchedOptions']
              : options
          }
          onChange={({ value }) => this.updateFilterField(field, true, value)}
          onSearch={(value) => this.searchOptions(field, value)}
          {...commonProps}
          {...optionProps}
        />
      )
    }
    return useCheckBoxValue ? null : (
      <TextInput
        {...commonProps}
        onChange={(e) => this.updateFilterField(field, true, e.target.value)}
      />
    )
  }
  render() {
    const { allowUpdate } = this.state
    const { apiFilters = [] } = this.props
    return (
      <Box gap="small" width={{ min: 'small', max: 'medium' }}>
        {apiFilters.length &&
          apiFilters.map((obj) => (
            <FormField key={'form-' + obj.field} name={obj.field}>
              <CheckBox
                label={obj.label}
                checked={this.isFieldSelected(obj.field)}
                onChange={(e) => this.updateFilterField(obj.field, e.target.checked)}
              />
              {this.isFieldSelected(obj.field) && this.getRenderComponent(obj.field)}
            </FormField>
          ))}

        <Button
          primary
          disabled={!allowUpdate}
          label={'APPLY'}
          onClick={this.triggerUpdateAction}
        />
      </Box>
    )
  }
}

const withOpsApi = (WrappedComponent, wrappedProps) => {
  class WithOpsApi extends Component {
    static contextType = AppContext
    static defaultProps = {
      apiParams: {},
      apiFilters: [],
      apiGroupBy: [],
      loaderProps: {}
    }
    defaultState = {
      apiPath: '',
      apiParams: {},
      apiFilters: [],
      nextUrl: null,
      resultFields: [],
      resultPageSize: undefined,
      submitting: false,
      showLayer: false,
      apiLoading: false,
      results: [],
      selectedFilters: {},
      selectedResult: {},
      filtersToPassThrough: {},
      showFilters: false,
      initialLoad: true,
      resultCount: 0
    }
    state = { ...this.defaultState, selectedDate: getMonthEnd() }
    componentDidMount = () => {
      console.log('MOUNTING DRF...')
      this.setApiStatesFromProps()
    }

    exportFileFunc = async ({ columns, data, fileName, workSheetName }) => {
      const workbook = new Excel.Workbook()

      try {
        const worksheet = workbook.addWorksheet(workSheetName)

        worksheet.columns = columns

        // updated the font for first row.
        worksheet.getRow(1).font = { bold: true }

        // loop through all of the columns and set the alignment with width.
        worksheet.columns.forEach((column) => {
          column.width = column.header.length + 5
          column.alignment = { horizontal: 'left' }
        })
        data.forEach((singleData) => {
          worksheet.addRow(singleData)
        })

        worksheet.eachRow({ includeEmpty: false }, (row) => {
          // store each cell to currentCell
          const currentCell = row._cells

          // loop through currentCell to apply border only for the non-empty cell of excel
          currentCell.forEach((singleCell) => {
            // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
            const cellAddress = singleCell._address

            // apply border
            worksheet.getCell(cellAddress).border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            }
          })
        })

        const buf = await workbook.xlsx.writeBuffer()
        // download the processed file
        saveAs(new Blob([buf]), `${fileName}.xlsx`)
        return true
      } catch (error) {
        console.error('<<<ERRROR>>>', error)
        this.context.actions.showResponseAsError(error)
      } finally {
        // removing worksheet's instance to create new one
        workbook.removeWorksheet(workSheetName)
      }
    }

    componentDidUpdate = (prevProps, prevState, snapsho) => {
      const apiGroupByProp = prevProps.apiGroupBy !== this.props.apiGroupBy
      const apiPathProp = prevProps.apiPath !== this.props.apiPath
      const apiPath = prevState.apiPath !== this.state.apiPath
      // todo: `filtersToPassThrough` does not trigger an update right now when using `apiFilters`
      // todo: object comparison via fast method for now, order of keys matters here
      const apiParamsProp =
        JSON.stringify(prevProps.apiParams) !== JSON.stringify(this.props.apiParams)
      const apiParams = JSON.stringify(prevState.apiParams) !== JSON.stringify(this.state.apiParams)
      // todo: end

      if (this.state.resultPageSize === undefined && this.state.results.length) {
        this.setState({ resultPageSize: this.state.results.length })
      }
      if (this.state.resultFields.length === 0 && this.state.results.length > 0) {
        this.setState({ resultFields: Object.keys(this.state.results[0]) })
      }
      if (this.state.apiPath && (apiPath || apiParams) && this.state.apiLoading === false) {
        this.loadFromApi(this.state.apiPath === this.props.apiPath)
        // this.loadFromApi()
      }
      if (this.state.apiLoading !== prevState.apiLoading) {
        this.props.loadingStateAction && this.props.loadingStateAction(this.state.apiLoading)
      }
      if (apiPathProp || apiParamsProp) {
        console.log('UPDATING DRF...', [
          prevProps.apiPath,
          this.props.apiPath,
          apiPathProp,
          prevProps.apiParams,
          this.props.apiParams,
          apiParamsProp
        ])

        this.setApiStatesFromProps()
      }
    }
    setApiStatesFromProps = () => {
      console.log('Set initial drf properties')
      console.log('setting drf:', this.props.apiPath, this.props.apiParams)
      const { apiPath, apiParams, apiFilters } = this.props
      let extractedParams = { ...apiParams }
      let selectedFields = {}
      apiFilters.forEach((filter) => {
        // is a user exposed filter field passed in as a part of the url parameters,
        // if so extract it and set it as a filter
        const paramValue = apiParams[filter.field]
        if (paramValue !== undefined) {
          delete extractedParams[filter.field]
          selectedFields[filter.field] = { value: paramValue }
        }
      })
      this.updateSelectedFiltersState(selectedFields, () => {
        this.setState({
          apiPath: apiPath,
          apiParams: extractedParams,
          apiFilters: apiFilters
        })
      })
    }
    loadOnMore = () => {
      console.log('Loading more entries')
      if (this.state.apiLoading === false && this.state.apiPath && this.state.nextUrl) {
        this.loadFromApi()
      } else {
        console.log('...nothing to load right now')
      }
    }
    loadFromApi = (reset = false) => {
      const { apiPath, apiParams, nextUrl, filtersToPassThrough } = this.state
      const { _options = {}, ...drfApiParams } = apiParams
      const allParams = { ...drfApiParams, ...filtersToPassThrough }
      const loadNextUrl = nextUrl && !reset
      console.log('Loading from Api', loadNextUrl ? nextUrl : [apiPath, allParams])
      reset && console.log('...clearing results')
      this.setState({ apiLoading: true, ...(reset && { initialLoad: true }) })

      const promise = loadNextUrl
        ? opsAPI.getFullPath(nextUrl, _options)
        : opsAPI.get(apiPath, allParams, _options)

      const responses = Promise.all([promise])
      responses
        .then((result) => {
          const { count, results, next, id } = result[0].data
          const items = results || []
          const isSingleItem = id !== undefined && results === undefined
          this.setState({
            apiLoading: false,
            initialLoad: false,
            resultCount: count,
            results: reset ? items : update(this.state.results, { $push: items }),
            result: isSingleItem ? result[0].data : null,
            nextUrl: next
          })
        })
        .catch((err) => {
          this.setState({ apiLoading: false, initialLoad: false })
          this.context.actions.showResponseAsError(err)
        })
    }
    // getSupplierReceiverName = (id, receiver = false) => {
    //   const { companies, receivers } = this.context
    //   if (!id) {
    //     return
    //   }
    //   if (receiver) {
    //     return receivers[id].name
    //   } else {
    //     return companies[id].name
    //   }
    // }
    updateSelectedFiltersState = (selectedFilters, callback) => {
      // `filtersToPassThrough` will be passed down to api endpoints along with the `drfApiParams`
      // they should not contain objects and be friendly to url endpoints
      let filtersToPassThrough = {}
      Object.keys(selectedFilters).forEach((key) => {
        if (selectedFilters[key] && selectedFilters[key].value !== undefined) {
          filtersToPassThrough[key] = selectedFilters[key].value
        }
      })
      this.setState(
        {
          selectedFilters: selectedFilters,
          filtersToPassThrough: filtersToPassThrough,
          showFilters: false
        },
        callback && callback
      )
    }
    updateSelectedFilters = (selectedFilters) => {
      this.updateSelectedFiltersState(selectedFilters, () => this.loadFromApi(true))
    }
    setSelectedResult = ({ index, result }) => {
      this.setState({ showLayer: true, selectedResult: result })
    }
    // resetGroupedKeys = () => {
    //   const { apiGroupBy } = this.props
    //   const grouped = {}
    //   apiGroupBy.forEach((key) => {
    //     grouped[key] = []
    //   })
    //   this.setState({ resultsGrouped: grouped })
    // }
    groupByKeys = (keys, reset = false) => {
      const { results } = this.state
      const grouped = {}
      // add keys
      if (results && results.length > 0) {
        keys.forEach((key) => {
          console.log(key, typeof key)
          if (key in results[0]) {
            grouped[key] = {}
          }
        })
        // add row to each key we want to group
        results.forEach((row) => {
          Object.keys(grouped).forEach((key) => {
            const subKey = row[key]
            if (!(subKey in grouped[key])) {
              grouped[key][subKey] = []
            }
            grouped[key][subKey].push(row)
          })
        })
        console.log('groups', grouped)
      }
      return grouped

      // Object.keys(grouped).forEach((key) => {
      //   Object.keys(grouped[key]).forEach((subKey) => {
      //     const prev = this.state.resultsGrouped[key + '_' + subKey] || []
      //     this.setState({
      //       resultsGrouped: update(this.state.resultsGrouped, {
      //         [key + '_' + subKey]: { $set: prev.concat(grouped[key][subKey]) }
      //       })
      //     })
      //   })
      // })
    }

    render() {
      const { showLayer, ...passThroughState } = this.state
      // const { companies, receivers, stores } = this.context
      const {
        apiPath,
        apiParams,
        loadingStateAction,
        loaderProps,
        ...passThroughProps
      } = this.props
      const {
        results,
        apiLoading,
        apiFilters,
        selectedFilters,
        showFilters,
        initialLoad,
        filtersToPassThrough
      } = this.state
      const filterCounter = Object.keys(filtersToPassThrough).length
      const actions = {
        // loadFromApi: this.loadFromApi,
        loadOnMore: this.loadOnMore,
        setSelectedResult: this.setSelectedResult,
        groupResults: this.groupByKeys
      }
      return !initialLoad ? (
        <WrappedComponent
          fromApi={passThroughState}
          exportFileFunc={this.exportFileFunc}
          apiActions={actions}
          {...passThroughProps}
          apiFilterMenu={
            apiFilters.length && (
              <DropWithHeading
                icon={<Filter color={'dark-6'} />}
                heading={'filters'}
                label={filterCounter ? filterCounter : undefined}
                open={showFilters}
                plain={false}
                // fill={'vertical'}
                size={'small'}
                onOpen={() => this.setState({ showFilters: true })}
                onClose={() => this.setState({ showFilters: false })}
                // label={}
              >
                <Filters
                  apiFilters={apiFilters}
                  selected={selectedFilters}
                  updateFiltersAction={this.updateSelectedFilters}
                />
              </DropWithHeading>
            )
          }
        />
      ) : (
        <LoadingHeader loading={apiLoading} {...loaderProps} />
      )
    }
  }
  return WithOpsApi
}

export default withOpsApi
